import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Set Discount Group Status Step (Discounts v2).
 *
 * Records the outcome of a discount-group approval: APPROVED activates every
 * element in the group (this is the "loop through all the elements and make
 * them active" step of discount-request / bulk-discount approval); REJECTED leaves them
 * inactive. Wired downstream of the Approval step's group sockets in the
 * group-approval workflow template.
 *
 * Backend-only (DB access); handler in
 * backend/src/workflows/steps/accounts-receivable/.
 */
export const setDiscountGroupStatusStep = defineStepConfig({
  type: "set_discount_group_status",
  name: "Set Discount Group Status",
  description:
    "Marks a discount group approved (activating all its elements) or rejected",
  category: "Data Access",
  libraryModule: "OrderManagement",
  inputSchema: z.object({
    discountGroupId: z
      .string()
      .uuid()
      .describe("UUID of the discount group to update"),
  }),

  outputSchema: z.object({
    discountGroupId: z.string().uuid(),
    status: z.enum(["APPROVED", "REJECTED"]),
    /** Number of elements activated (0 for REJECTED). */
    activatedElementCount: z.number().int(),
  }),

  configSchema: z.object({
    status: z
      .enum(["APPROVED", "REJECTED"])
      .describe(
        "The status to set. APPROVED also flips every element in the group active.",
      ),
  }),

  emits: [] as const,
});
